import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useMentionRef(activeOnly: boolean) {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    ["ref-mentions", activeOnly],
    async () => {
      return await api.mentions(activeOnly);
    },
    { staleTime: Infinity }
  );

  return {
    cadres: data ?? [],
    cadresLoading: isFetching,
    refetchCadresRef: refetch,
  };
}
